export class StorageItem {
    key;
    value;
    constructor(data) {
        this.key = data.key;
        this.value = data.value;
    }
}
// class for working with session storage in browser (common that can use other classes for store some data)
export class SessionStorageWorker {
    sessionStorageSupported;
    constructor() {
        this.sessionStorageSupported =
            typeof window.sessionStorage !== "undefined" &&
                window.sessionStorage != null;
    }
    // add value to storage
    add(key, item) {
        if (this.sessionStorageSupported) {
            sessionStorage.setItem(key, item);
        }
    }
    // get all values from storage (all items)
    getAllItems() {
        const list = new Array();
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            const value = sessionStorage.getItem(key);
            list.push(new StorageItem({
                key: key,
                value: value
            }));
        }
        return list;
    }
    // get only all values from sessionStorage
    getAllValues() {
        const list = new Array();
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            const value = sessionStorage.getItem(key);
            list.push(value);
        }
        return list;
    }
    // get one item by key from storage
    get(key) {
        if (this.sessionStorageSupported) {
            const item = sessionStorage.getItem(key);
            return item;
        }
        else {
            return null;
        }
    }
    // remove value from storage
    remove(key) {
        if (this.sessionStorageSupported) {
            sessionStorage.removeItem(key);
        }
    }
    // clear storage (remove all items from it)
    clear() {
        if (this.sessionStorageSupported) {
            sessionStorage.clear();
        }
    }
}
//# sourceMappingURL=storage-helper.js.map
